import React, { useState } from 'react'
import creatorLine from '../../../assets/creatorLine.svg'
import threeLine from '../../../assets/threeLines.svg'
// import Button from '../../../Components/Button/Button'
// import AlertDialog from '../../../Components/Dialog/Dialog'

const Creator = () => {

  // const [open, setOpen] = React.useState(false)

  // const handleClickOpen = () => {
  //   setOpen(true)
  // }

  // const handleClose = () => {
  //   setOpen(false)
  // }

  return (
    <div className="crContainer" id="Values">
      <div>
        <div>
          <div className="crtHead">
            {/* <img className="crtLine" src={creatorLine} alt="" /> */}
            <svg
              width="211"
              height="236"
              className="crtLine"
              viewBox="0 0 211 236"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M142.698 78.9612C142.69 78.8786 142.687 78.7944 142.685 78.7138C142.691 77.612 142.878 76.0084 142.989 74.1411C143.267 69.5502 143.068 63.464 139.097 59.0317C136.43 56.0533 132.07 53.7922 124.958 53.2555C121.659 53.0109 118.563 54.1978 115.83 56.1349C111.941 58.8849 108.8 63.1554 106.881 66.5908C106.113 67.9691 105.135 70.8626 104.286 72.8058C91.7894 33.0041 25.1045 31.8647 5.71687 75.444C5.48593 75.9616 5.75058 76.5016 6.29974 76.6538C6.8517 76.8009 7.48737 76.5043 7.71831 75.9867C26.518 33.7359 91.6857 35.4059 102.585 74.8453C102.784 75.5653 103.191 75.8423 103.478 75.9381C103.899 76.0754 104.369 76.0305 104.857 75.6568C105.22 75.3769 105.73 74.608 106.198 73.5503C107.041 71.6542 108.022 68.6944 108.798 67.3006C110.569 64.1264 113.451 60.1569 117.044 57.6155C119.296 56.0208 121.829 54.9965 124.539 55.1978C130.964 55.6808 134.94 57.664 137.353 60.3549C140.998 64.4255 141.078 70.0416 140.828 74.2552C140.69 76.5034 140.46 78.3804 140.535 79.4991C140.586 80.2489 140.807 80.7489 141.087 81.0144C141.232 81.1491 141.587 81.3893 142.21 81.2358C142.816 81.0852 145.318 79.804 145.754 79.63C157.688 74.9071 168.289 79.2373 174.196 88.0486C184.094 102.815 178.633 116.019 167.621 121.685C157.993 126.641 144.363 125.775 133.348 115.381C133.042 115.02 132.735 114.656 132.432 114.289C131.404 113.053 128.654 109.892 128.212 109.498C127.598 108.948 126.885 109.352 126.782 109.417C126.535 109.578 126.201 109.871 126.269 110.406C126.274 110.457 126.342 110.712 126.648 111.122C128.233 113.236 129.906 115.107 131.641 116.751C133.245 118.65 134.865 120.53 136.361 122.508C142.494 130.625 148.16 139.249 150.525 149.193C153.227 160.536 151.815 176.945 145.151 189.189C141.887 195.184 137.366 200.176 131.396 203C125.431 205.827 118.049 206.458 109.105 203.855C108.558 203.694 107.919 203.984 107.678 204.498C107.436 205.011 107.688 205.556 108.236 205.717C117.858 208.515 125.811 207.743 132.23 204.703C138.65 201.666 143.566 196.329 147.075 189.879C153.958 177.237 155.436 160.298 152.647 148.585C150.308 138.761 144.851 130.19 138.833 122.139C149.034 127.997 160.219 127.629 168.531 123.35C180.47 117.208 186.814 102.919 176.085 86.9091C169.658 77.3193 158.066 72.7197 145.074 77.8596C144.819 77.9628 143.56 78.5515 142.698 78.9612Z"
                fill="#111111"
                stroke="#ABFF29"
                strokeWidth={3.7}
              />
            </svg>
            <p>
              By Creators <br /> for Creators
            </p>
            <img className="thLine" src={threeLine} alt="" />
          </div>
          <div className="crtTxtBox">
            <div className="crtTxt">
              <p className="nmSzTxt">
                Community-owned IP may sound like a risk for creators. Creators
                are used to being the masters of their worlds. This is why we
                are starting with our own Crypto-Z. We aim to lead, not by
                promises, but by example.
              </p>
            </div>
            <div className="crtTxt">
              <p className="nmSzTxt">
                At our core, we are a team of creators and storytellers. We have
                experienced firsthand the fundamental misalignments driving the
                entertainment industry.
              </p>
            </div>
            <div className="crtTxt">
              <p className="nmSzTxt">
                Community-owned IPs can flip the system on its head by aligning
                creators and fans towards the same goal of creating stories that
                continue forever.
              </p>
            </div>
            <div className="crtTxt">
              <p className="nmSzTxt">
                A story’s best chance for timelessness isn’t through a
                corporation. It is a community superpowered by ownership.
              </p>
            </div>
            {/* <div className="crtBtn">
              <AlertDialog  isOpen={open} handleClose={handleClose} />
              <Button
                text="Sign Open Letter"
                isGreen={true}
                onClick={handleClickOpen}
              />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Creator
